import React, { useCallback } from 'react'

import clsx from 'clsx'

import ToDoCheckbox from '$extensionSrc/components/ToDoCheckbox'
import { EmailSingleSettingUpdate } from '$extensionSrc/notifications/notificationTypes'

import styles from './NotificationSettingRow.module.scss'

export default function NotificationSettingRow({
  category,
  description,
  name,
  onSingleSettingUpdate,
  settingId,
  settingValue,
}: {
  category: string
  description: string
  name: string
  onSingleSettingUpdate: (ssu: EmailSingleSettingUpdate) => void
  settingId: string
  settingValue: boolean
}) {
  const handleClickSettingCheckbox = useCallback(() => {
    onSingleSettingUpdate({
      category,
      settingId,
      targetValue: !settingValue,
    })
  }, [category, onSingleSettingUpdate, settingId, settingValue])

  return (
    <div className={styles.NotificationSettingRow}>
      <div className="notification-setting-label">
        <div className="body1 bold">{name}</div>
        <div className="body2">{description}</div>
      </div>
      <div className={clsx(styles.notificationSettingValues)}>
        <div className={clsx(styles.notificationChannelCheckbox)}>
          <ToDoCheckbox
            isSettingSelected={settingValue}
            labelId={settingId}
            onClick={handleClickSettingCheckbox}
          />
        </div>
      </div>
    </div>
  )
}
